// src/screens/ClaimScreen.js - Handles voucher claim when customer clicks email link
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { claimVoucher } from "../services/voucherService";

const ClaimScreen = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [voucher, setVoucher] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    handleClaim();
  }, []);

  const handleClaim = async () => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (!token) {
      setError("Invalid claim link. No token provided.");
      setLoading(false);
      return;
    }

    try {
      const result = await claimVoucher(token);

      if (result.error) {
        setError(result.error);
      } else {
        setVoucher(result);
      }
    } catch (err) {
      console.error("Error claiming voucher:", err);
      setError(err.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="screen-container">
        <div className="thank-you-container">
          <div className="loading-spinner"></div>
          <h1 className="thank-you-title">Claiming Your Voucher...</h1>
          <p className="thank-you-message">Please wait while we prepare your promo code.</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="screen-container">
        <div className="thank-you-container">
          <div
            className="thank-you-icon"
            style={{ background: "#fff3e0", color: "#e65100" }}
          >
            !
          </div>
          <h1 className="thank-you-title">Oops</h1>
          <p className="thank-you-message">{error}</p>
          <button
            className="button"
            onClick={() => navigate("/")}
            style={{ maxWidth: "200px", margin: "16px auto 0" }}
          >
            Go Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="screen-container">
      <div className="thank-you-container">
        <div className="thank-you-icon" style={{ fontSize: "2rem" }}>
          🎉
        </div>
        <h1 className="thank-you-title">
          {voucher.alreadyClaimed ? "Voucher Already Claimed" : "Your Voucher!"}
        </h1>
        <p className="thank-you-message">
          {voucher.alreadyClaimed
            ? "You've already claimed this voucher. Here are your details again."
            : "Congratulations! Your promo code has been redeemed."}
        </p>

        <div
          style={{
            background: "#f8f9fa",
            border: "2px dashed #4caf50",
            borderRadius: "12px",
            padding: "24px",
            textAlign: "center",
            margin: "20px 0",
          }}
        >
          <div
            style={{
              fontSize: "0.75rem",
              textTransform: "uppercase",
              color: "#888",
              letterSpacing: "1px",
              marginBottom: "8px",
            }}
          >
            Your Promo Code
          </div>
          <div
            style={{
              fontSize: "1.8rem",
              fontWeight: "700",
              fontFamily: "monospace",
              color: "#333",
              letterSpacing: "3px",
            }}
          >
            {voucher.code}
          </div>
        </div>

        {voucher.url && (
          <a
            href={voucher.url}
            className="button"
            style={{
              display: "block",
              textDecoration: "none",
              textAlign: "center",
              marginBottom: "12px",
            }}
          >
            Redeem Now
          </a>
        )}

        {!voucher.url && (
          <p
            style={{
              fontSize: "0.85rem",
              color: "#888",
              textAlign: "center",
              marginTop: "12px",
            }}
          >
            Save this code - you may need it for redemption.
          </p>
        )}

        <button
          className="button"
          onClick={() => navigate("/")}
          style={{
            maxWidth: "200px",
            margin: "16px auto 0",
            background: "#666",
          }}
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default ClaimScreen;
